import ordersApiService from './ordersApiService';
import backendApiService from './backendApiService';
import localDbService from './localDbService';
import { API_CONFIG } from '../config/apiConfig';

class SyncService {
  constructor() {
    this._intervalId = null;
    this._running = false;
  }

  async runOnce() {
    if (this._running) return;
    this._running = true;
    try {
      const codes = API_CONFIG.SYNC.CUSTOMER_CODES || ['430'];
      const to = new Date();
      const from = new Date(to.getTime() - (API_CONFIG.SYNC.DATE_RANGE_DAYS || 365) * 24 * 60 * 60 * 1000);
      const date_from = from.toISOString().slice(0, 10);
      const date_to = to.toISOString().slice(0, 10);
      const raw = await backendApiService.getCustomersOrdersComplete(codes, { date_from, date_to });
      const list = Array.isArray(raw) ? raw : (raw?.data ?? []);
      const ordersOnly = list.filter(r => {
        const t = (r?.type || r?.tipo || '').toString().toLowerCase();
        return !t || t === 'order';
      });
      const mapped = ordersOnly.map(o => ordersApiService.mapOrder(o));
      await localDbService.importOrders(mapped);
      try {
        const evt = new Event('sync:orders-updated');
        window.dispatchEvent(evt);
      } catch (_e) {}
    } finally {
      this._running = false;
    }
  }

  start(intervalMs = API_CONFIG.SYNC.INTERVAL_MS) {
    this.stop();
    this.runOnce().catch(() => {});
    this._intervalId = setInterval(() => {
      this.runOnce().catch(() => {});
    }, intervalMs);
  }

  stop() {
    if (this._intervalId) {
      clearInterval(this._intervalId);
      this._intervalId = null;
    }
  }
}

const syncService = new SyncService();
export default syncService;

